export type FilterOperator =
  | 'eq'
  | 'neq'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'like'
  | 'ilike'
  | 'is'
  | 'in'
  | 'cs'
  | 'cd'
  | 'sl'
  | 'sr'
  | 'nxl'
  | 'nxr'
  | 'adj'
  | 'ov'
  | 'fts'
  | 'plfts'
  | 'phfts'
  | 'wfts';

export interface QueryPagination {
  readonly startIndex: number;
  readonly endIndex: number;
  readonly page: number;
  readonly perPage: number;
}

export interface ResultsPagination extends QueryPagination {
  readonly totalRows: number;
  readonly isNextPage: boolean;
  readonly isPrevPage: boolean;
  readonly numberOfPages: number;
}

export const getQueryPagination = (page: number, perPage: number): QueryPagination => {
  page = Math.floor(page) || 1;
  perPage = Math.floor(perPage) || 1;
  const startIndex = (page - 1) * perPage;
  return {
    page,
    perPage,
    startIndex,
    endIndex: startIndex + perPage - 1,
  };
};

export const getResultsPagination = (queryPagination: QueryPagination, totalRows = 0) => {
  const numberOfPages = Math.max(Math.ceil(totalRows / queryPagination.perPage), 1);
  return {
    ...queryPagination,
    totalRows,
    numberOfPages,
    isNextPage: queryPagination.page < numberOfPages,
    isPrevPage: queryPagination.page > 1,
  };
};

export type QueryFilterType = `${'' | 'not.'}${FilterOperator}`;
export type QueryFilter = [string, QueryFilterType, unknown];

export type SortField = {
  field: string;
  ascending?: boolean;
  nullsFirst?: boolean;
};

export type FindManyQueryParams = {
  page?: number;
  perPage?: number;
  filters?: QueryFilter[];
  search?: string;
  sort?: SortField;
  select?: string;
};

export interface ListResult<T> {
  data: T[];
  pagination: ResultsPagination;
}

export interface RowWithIdAndName {
  id: string;
  name: string;
}

export interface RowWithCodeAndName {
  code: string;
  name: string;
}

export type IdNamePair = [id: string, name: string];

export type CodeNamePair = [code: string, name: string];
